module.exports = __webpack_public_path__ + "img/linkedin.0b12bd70.png";